'use strict';
var GEO_DATA, Geocoder, KeywordBar, Location, LocationBar, LocationError, SearchBarView, Typeahead, breakDownAddress, detectCurrentLocation, getGeoSearchOverrideUrl, getLocationForSearch, getLocationOverrideUrl, getSearchOverrideUrl, getSearchUrl, isBlank, locationHasChanged, placeholderState, redirectToUrl, ref, removeGeolocationData, saveRecentSearch, setSiteCookies, storeGeolocationData, storeLocationData, trackEvent,
  bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; };

KeywordBar = require('../helper/search/view/m_keyword_bar');

Location = require('../helper/search/helper/m_location_helper');

LocationBar = require('../helper/search/view/m_location_bar');

LocationError = require('../helper/search/view/m_error');

Typeahead = require('../helper/search/view/m_typeahead');

Geocoder = require('../helper/search/common/m_geocoder');

setSiteCookies = require('../helper/general/m_setSiteCookies');

redirectToUrl = require('../helper/general/m_setWindowLocation');

trackEvent = require('../helper/general/m_trackEvent');

isBlank = require('../../../core/frontend/common/underscore_mixins').isBlank;

ref = require('../helper/search/helper/m_searchbar_helper'), breakDownAddress = ref.breakDownAddress, getGeoSearchOverrideUrl = ref.getGeoSearchOverrideUrl, getLocationForSearch = ref.getLocationForSearch, getLocationOverrideUrl = ref.getLocationOverrideUrl, getSearchOverrideUrl = ref.getSearchOverrideUrl, getSearchUrl = ref.getSearchUrl, GEO_DATA = ref.GEO_DATA, removeGeolocationData = ref.removeGeolocationData, storeGeolocationData = ref.storeGeolocationData, storeLocationData = ref.storeLocationData;

saveRecentSearch = require('../helper/search/helper/m_typeahead_helper.coffee').saveRecentSearch;

detectCurrentLocation = require('../helper/search/helper/m_detectCurrentLocation').detectCurrentLocation;

placeholderState = require('../helper/search/helper/m_common').placeholderState;

locationHasChanged = void 0;

module.exports = SearchBarView = (function() {
  var keyword, translations;

  keyword = translations = void 0;

  function SearchBarView() {
    this._redirectTo = bind(this._redirectTo, this);
    this._geocoderError = bind(this._geocoderError, this);
    this._geocoderSuccess = bind(this._geocoderSuccess, this);
    this._searchWithPlaces = bind(this._searchWithPlaces, this);
    this._searchWithAutocomplete = bind(this._searchWithAutocomplete, this);
    this._searchWithGmaps = bind(this._searchWithGmaps, this);
    this._searchWithGeolocation = bind(this._searchWithGeolocation, this);
    this._cleanGeolocationTraces = bind(this._cleanGeolocationTraces, this);
    this._gatherData = bind(this._gatherData, this);
    this._getQuery = bind(this._getQuery, this);
    this.setSearchbarFocusTracking = bind(this.setSearchbarFocusTracking, this);
    this.onFormSubmit = bind(this.onFormSubmit, this);
  }

  SearchBarView.prototype.init = function(opts) {
    var base, elements, name, ref1, selector;
    elements = opts.elements, this.env = opts.env, this.options = opts.options;
    for (name in elements) {
      selector = elements[name];
      this['$' + name] = $(selector);
    }
    this.$inputs = (ref1 = this.$search) != null ? ref1.add(this.$location) : void 0;
    this.useLocationPlacesAPI = false;
    this.render(this.options);
    if (typeof (base = this.options).setExperiments === "function") {
      base.setExperiments();
    }
    this.bindFormSubmit();
    this.bindDefault();
    this.bind();
    this.country = I18n.country;
    translations = opts.translations || Groupon.LS.translations || {};
    this.geolocationData = Location.getGeolocationData();
  };


  /*
   * Bind form submit handler
   */

  SearchBarView.prototype.bindFormSubmit = function() {
    return this.$form.on('submit', (function(_this) {
      return function(e) {
        return _this.onFormSubmit(e);
      };
    })(this));
  };

  SearchBarView.prototype.bindDefault = function() {

    /*
     * Input events
     */
    this.$inputs.on('input focusin', (function(_this) {
      return function(e) {
        var el;
        el = e.currentTarget;
        placeholderState.toggle($(el));
        e.preventDefault();
        return _this.typeahead.buildAutocompleteListThrottle(_.clone(e), el.name);
      };
    })(this));

    /*
     * Typeahead events
     */
    this.$resultList.on('click', 'a', (function(_this) {
      return function(e) {
        var $trigger, ref1;
        if (e != null ? (ref1 = e.currentTarget) != null ? ref1.href : void 0 : void 0) {
          return;
        }
        $trigger = $(e.currentTarget);
        e.preventDefault();
        return _this.selectAndFill($trigger);
      };
    })(this));
    return $(window).one('load', (function(_this) {
      return function() {
        return _this.$form.find('input').each(function() {
          return placeholderState.toggle($(this));
        });
      };
    })(this));
  };

  SearchBarView.prototype.bind = function() {};

  SearchBarView.prototype.selectAndFillWithoutSubmit = function($trigger) {
    var $widget, source;
    $widget = this.$resultList;
    $widget.find('.typeahead-match').removeClass('typeahead-match');
    if ($widget.hasClass('typeahead-location')) {
      source = 'location';
      this._updateValueAndLatLng($trigger, this.$location);
    } else {
      source = 'deal';
      this._updateValue($trigger, this.$search);
    }
    return source;
  };


  /**
   * Autocomplete link handler
   * Updates deal or location input
   *
   * @param {Object} e - jQuery event
   */

  SearchBarView.prototype.selectAndFill = function($trigger) {
    this.selectAndFillWithoutSubmit($trigger);
    this.$form.trigger('submit');
  };

  SearchBarView.prototype.render = function(opts) {
    var experiments, flags, options, ref1, ref2, ref3;
    ref1 = Groupon.LS, options = ref1.options, experiments = ref1.experiments, flags = ref1.flags;
    if (options == null) {
      options = {};
    }
    options = Object.assign({}, options, experiments, flags, opts, {
      fetchWithPlacesApi: this.useLocationPlacesAPI
    });
    this.typeahead = new Typeahead({
      env: this.env,
      resultList: this.$resultList,
      endpoints: {
        search: (ref2 = Groupon.endpoints) != null ? ref2.deals : void 0,
        location: (ref3 = Groupon.endpoints) != null ? ref3.locations : void 0
      },
      options: options,
      experiments: experiments
    });
    if (this.$search != null) {
      this.keywordBar = new KeywordBar({
        $form: this.$form,
        env: this.env
      });
    }
    if (this.$location != null) {
      this.locationError = new LocationError({
        $form: this.$form,
        env: this.env,
        $resultList: this.$resultList,
        enableBetterUx: options.enableBetterUx
      });
      this.locationBar = new LocationBar({
        $form: this.$form,
        env: this.env
      });
    }
    return this.setSearchbarFocusTracking();
  };

  SearchBarView.prototype.onFormSubmit = function(e) {
    var data, fn, overrideUrl, ref1, state;
    e.preventDefault();
    state = this.locationState;
    ref1 = this._gatherData(state), data = ref1.data, state = ref1.state;
    if (data == null) {
      return;
    }
    if (typeof this.lockSubmit === "function") {
      this.lockSubmit(true);
    }
    overrideUrl = getGeoSearchOverrideUrl(data.query, data.address);
    if (overrideUrl != null) {
      return redirectToUrl(overrideUrl);
    }
    locationHasChanged = true;
    switch (state) {
      case 'geolocate':
        data.currentLocation = true;
        locationHasChanged = false;
        fn = this._searchWithGeolocation;
        break;
      case 'autocomplete':
        fn = this._searchWithAutocomplete;
        Location.removeGeolocationData('current_location');
        if (this.useLocationPlacesAPI && data.place_id) {
          fn = this._searchWithPlaces;
        }
        break;
      case 'manual':
        fn = this._searchWithGmaps;
        Location.removeGeolocationData('current_location');
        break;
      default:
        locationHasChanged = false;
        fn = this._redirectTo;
    }
    return (fn.bind(this))(data);
  };

  SearchBarView.prototype.setSearchbarFocusTracking = function() {
    return this.$form.on('focusin.searchbar', (function(_this) {
      return function(e) {
        if (e.target && $(e.currentTarget).find(e.target).length) {
          trackEvent('searchbar-focusin');
          _this.$form.off('focusin.searchbar');
          return _this.$form.on('focusout.searchbar', function(event) {
            if (!$(event.currentTarget).find(event.relatedTarget).length) {
              trackEvent('searchbar-focusout');
              _this.$form.off('focusout.searchbar');
              return _this.setSearchbarFocusTracking();
            }
          });
        }
      };
    })(this));
  };


  /*
   * ------------------
   * PRIVATE NON-PUBLIC
   * ------------------
   */


  /**
   * Set location data to location input from autocomplete item
   *
   * @param {Object} $trigger - jQuery object of autocomplete item
   */

  SearchBarView.prototype._updateValueAndLatLng = function($source, $target) {
    var data, division, lat, lng, place_id, ref1, value;
    ref1 = $source.data(), value = ref1.value, lat = ref1.lat, lng = ref1.lng, division = ref1.division, place_id = ref1.place_id;
    if ($source.hasClass('current-location')) {
      this.locationState = 'geolocate';
      value = translations.search.nearme;
      data = {
        current_location: true,
        manual: false,
        value: value
      };
    } else {
      this.locationState = 'autocomplete';
      data = this.useLocationPlacesAPI && place_id ? {
        place_id: place_id,
        'manual': false,
        value: value
      } : {
        lat: lat.toString(),
        lng: lng.toString(),
        division: division,
        'manual': false,
        value: value
      };
    }
    $target.val(value).data(data);
  };


  /**
   * Write deal data to deal input from autocomplete item
   *
   * @param {Object} $source - jQuery object of autocomplete item
   */

  SearchBarView.prototype._updateValue = function($source, $target) {
    if ($source == null) {
      $source = {};
    }
    if ($target == null) {
      $target = {};
    }
    placeholderState.set($target, 'hide');
    $target.val($source.data('value'));
  };

  SearchBarView.prototype._getQuery = function() {
    var maxChars, ref1, ref2;
    maxChars = this.$search.attr('maxlength') || 50;
    keyword = (ref1 = this.keywordBar) != null ? (ref2 = ref1.val()) != null ? ref2.trim().slice(0, maxChars) : void 0 : void 0;
    if (!isBlank(keyword)) {
      return keyword;
    }
  };

  SearchBarView.prototype._pickLocationData = function(data, withGEO) {
    var paths;
    if (withGEO == null) {
      withGEO = false;
    }
    paths = ['lat', 'lng', 'closestDivision', 'division', 'place_id'];
    if (withGEO) {
      paths = paths.concat(GEO_DATA);
    }
    return _.pick(data, paths);
  };

  SearchBarView.prototype._gatherData = function(state) {
    var data, dealSearch, geoMaximumAge, geolocationData, locData, locSearch, locationMatch, ref1, ref2, ref3;
    geolocationData = (ref1 = this.geolocationData) != null ? ref1.current_location : void 0;
    dealSearch = this._getQuery();
    locSearch = this.locationBar.val();
    data = null;
    if (!dealSearch && !locSearch) {
      return {
        state: state,
        data: data
      };
    }
    if (dealSearch != null) {
      saveRecentSearch(dealSearch, 'deal');
    }
    if ((locationMatch = $('.typeahead-location .typeahead-match')).length) {
      if (state == null) {
        state = 'autocomplete';
      }
      data = this._pickLocationData(locationMatch.data());
    } else {
      locData = this.$location.data();
      if (locData.manual && state === void 0) {
        state = 'manual';
      }
      if (locData.value && locData.value !== locSearch) {
        state = 'manual';
      }
      switch (state) {
        case 'autocomplete':
        case 'manual':
          data = this._pickLocationData(locData);
          break;
        default:
          data = this._pickLocationData(locData, true);
          geoMaximumAge = (ref2 = Groupon.Modules.SearchBar.geolocationOptions) != null ? ref2.maximumAge : void 0;
          if (geoMaximumAge && Date.now() - (geolocationData != null ? geolocationData.timeStamp : void 0) > geoMaximumAge) {
            state = 'geolocate';
          }
      }
    }
    if (!geolocationData || !data.closestDivision) {
      data.closestDivision = (ref3 = Groupon.division) != null ? ref3.id : void 0;
    }
    return {
      data: Object.assign(data, {
        address: locSearch,
        query: keyword
      }),
      state: state
    };
  };

  SearchBarView.prototype._cleanGeolocationTraces = function() {
    var data, lat, lng, name, options;
    Location.removeGeolocationData('current_location');
    Location.setGeolocationData('geoLocationGranted', false);
    if (translations.search.currentlocation === this.$location.val() && ((data = Groupon.division) != null)) {
      lat = data.lat, lng = data.lng, name = data.name;
      options = {
        address: name,
        lat: lat,
        lng: lng,
        geocoderSuccess: (function(_this) {
          return function(arg) {
            var locationData;
            locationData = arg.locationData;
            _this.$location.data(locationData).val(locationData.friendlyName);
            return Location.setSearchLocCookie(locationData);
          };
        })(this),
        geocoderError: function() {}
      };
      return this._searchWithGmaps(options);
    }
  };


  /**
   * HTML5 geolocation handler to get latitude and longitude
   * and perform geocoder lookup via Google Maps
   *
   * @param {Object} data
   */

  SearchBarView.prototype._searchWithGeolocation = function(data) {
    var geoLocationError, geolocationSuccess, query;
    if (data == null) {
      query = this._getQuery();
      data = {
        address: translations.search.nearme,
        query: query
      };
    }
    if (this.env === 'desktop') {
      $('.typeahead-response.location').hide();
    }
    geolocationSuccess = (function(_this) {
      return function(arg) {
        var lat, lng;
        lat = arg.lat, lng = arg.lng;
        _this.$location.val(data.address);
        data = Object.assign(data, {
          lat: lat,
          lng: lng,
          current_location: true
        });
        trackEvent('location-bar-geolocation-success', {
          lat: lat,
          lng: lng
        });
        Location.setGeolocationData('geoLocationGranted', true);
        return _this._searchWithAutocomplete(data);
      };
    })(this);
    geoLocationError = (function(_this) {
      return function(err) {
        _this._cleanGeolocationTraces();
        trackEvent('location-bar-geolocation-error', err);
        _this.locationError.displayAvailabilityError('current-location');
        return typeof _this.lockSubmit === "function" ? _this.lockSubmit(false) : void 0;
      };
    })(this);
    return detectCurrentLocation(geolocationSuccess, geoLocationError);
  };


  /**
   * Google Maps handler for geocoder lookup
   *
   * @param {Object} [options] - Location data
   */

  SearchBarView.prototype._searchWithGmaps = function(options) {
    var address, current_location, geocoderError, geocoderSuccess, lat, lng;
    if (options == null) {
      options = {};
    }
    address = options.address, current_location = options.current_location, lat = options.lat, lng = options.lng, geocoderSuccess = options.geocoderSuccess, geocoderError = options.geocoderError;
    options = {
      address: address,
      location: {
        lat: lat,
        lng: lng
      },
      current_location: current_location,
      country: this.country,
      geocoderSuccess: geocoderSuccess,
      geocoderError: geocoderError
    };
    if (!(geocoderSuccess || geocoderError)) {
      options = Object.assign({}, options, {
        geocoderSuccess: this._geocoderSuccess.bind(this),
        geocoderError: this._geocoderError.bind(this)
      });
    }
    if (!this.geocoder) {
      this.geocoder = new Geocoder();
    }
    return this.geocoder.geocode(options);
  };


  /**
   * Location autocomplete handler
   * Uses data to directly redirect or do closestDivision lookup
   *
   * @param {Object} data - Location data
   */

  SearchBarView.prototype._searchWithAutocomplete = function(data) {
    var address, locationData, query;
    address = data.address, query = data.query;
    trackEvent('location-bar-autocomplete-successful-match', {
      query: query,
      address: address
    });
    if (this.country === 'US') {
      data = breakDownAddress(data);
    }
    if (data.division) {
      locationData = Object.assign(data, data.geocoderData);
      delete locationData.geocoderData;
      data.closestDivision = data.division;
      return this._geocoderSuccess({
        address: data.address,
        locationData: locationData
      });
    }
    data = Object.assign({}, data, {
      geocoderSuccess: this._geocoderSuccess.bind(this),
      geocoderError: this._geocoderError.bind(this)
    });
    new Geocoder().fetchClosestDivision(data);
  };


  /**
   * LS-3106 search with Places API proxy and getClosestDivision
   *
   * @param {Object} placesData
   */

  SearchBarView.prototype._searchWithPlaces = function(placesData) {
    var address, ajaxConfig, error, place_id, query, ref1;
    address = placesData.address, query = placesData.query, place_id = placesData.place_id;
    trackEvent('location-bar-places-successful-match', placesData);
    error = (function(_this) {
      return function(err) {
        return _this._geocoderError({
          address: address,
          status: 'UNAVAILABLE',
          data: err
        });
      };
    })(this);
    ajaxConfig = {
      url: [(ref1 = Groupon.endpoints) != null ? ref1.places_details : void 0, 'v1'].join('/'),
      data: {
        place_id: place_id
      },
      headers: {
        'x-ls-client-req': true,
        'x-ls-locale': I18n.locale
      },
      success: (function(_this) {
        return function(arg) {
          var data, err;
          data = arg.data, err = arg.err;
          if (err) {
            return error(err);
          }
          return (_this._geocoderSuccess.bind(_this))({
            query: query,
            address: address,
            locationData: Object.assign(data, {
              locationId: place_id
            }),
            current_location: false
          });
        };
      })(this),
      error: error
    };
    $.ajax(ajaxConfig);
  };

  SearchBarView.prototype._geocoderSuccess = function(arg) {
    var address, currentLocationData, current_location, data, hasLocCookie, locationData, query, trackyEventName;
    address = arg.address, query = arg.query, locationData = arg.locationData, current_location = arg.current_location;
    Location.setELLCookie(locationData.lat + ',' + locationData.lng);
    if (query == null) {
      query = keyword;
    }
    if (locationData.fullAddress != null) {
      address = locationData.fullAddress;
    }
    trackyEventName = 'location-bar-geocode-search-success';
    if (current_location) {
      address = translations.search.nearme;
      trackyEventName = 'location-bar-geolocation-search-success';
      currentLocationData = _.pick(locationData, 'lat', 'lng', 'closestDivision', 'division', 'address');
      currentLocationData = Object.assign(currentLocationData, {
        timeStamp: new Date().getTime()
      });
      storeGeolocationData(current_location, currentLocationData);
    } else {
      removeGeolocationData();
    }
    locationData.address = locationData.friendlyName = address;
    Location.setSearchLocCookie(locationData);
    hasLocCookie = true;
    trackEvent(trackyEventName, {
      address: address,
      locationData: locationData,
      query: query
    });
    if ((data = locationData || getLocationForSearch())) {
      data = _.omit(data, ['fullAddress', 'friendlyName', 'types']);
      data = Object.assign(data, {
        query: query
      });
      return this._redirectTo(data, hasLocCookie);
    }
  };

  SearchBarView.prototype._geocoderError = function(arg) {
    var address, data, status;
    address = arg.address, status = arg.status, data = arg.data;
    if (typeof this.lockSubmit === "function") {
      this.lockSubmit(false);
    }
    if (status === 'ABORT') {
      return;
    }
    if (status === 'BAD_LOCATION') {
      this.locationError.displayBadLocationError(address);
    } else if (status === 'UNAVAILABLE') {
      this.locationError.displayAvailabilityError(address);
    }
    return trackEvent('location-bar-geocode-search-error', {
      address: address,
      data: data
    });
  };

  SearchBarView.prototype._redirectTo = function(data, hasLocCookie) {
    var address, closestDivision, division, newUrl, query, searchEvent;
    closestDivision = data.closestDivision, division = data.division;
    if (!((closestDivision != null) || (division != null))) {
      if (typeof this.lockSubmit === "function") {
        this.lockSubmit(false);
      }
      return;
    }
    if (closestDivision && !division) {
      division = closestDivision;
    }
    setSiteCookies({
      division: division
    });
    if (locationHasChanged) {
      storeLocationData(data);
    }
    address = data.address, query = data.query;
    searchEvent = query ? hasLocCookie ? 'deal-search-with-loc-cookie' : 'deal-search-with-no-loc-cookie' : 'location-search';
    trackEvent(searchEvent, {
      address: address,
      query: query
    });
    newUrl = getLocationOverrideUrl(data) || getSearchOverrideUrl(division, data, this.env === 'mobile') || getSearchUrl(division, _.omit(data, 'closestDivision'));
    Groupon.setWindowLocation(newUrl);
  };

  return SearchBarView;

})();

